function isAxiosResponseLike(payload) {
  return Boolean(
    payload &&
      typeof payload === 'object' &&
      'data' in payload &&
      'headers' in payload &&
      'config' in payload &&
      typeof payload.status === 'number'
  )
}

export function normalizeProfileData(payload) {
  if (isAxiosResponseLike(payload)) {
    return normalizeProfileData(payload.data)
  }

  return payload
}
